import { render, staticRenderFns } from "./RecipeView.vue?vue&type=template&id=2a9a340f&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"
import style0 from "./RecipeView.vue?vue&type=style&index=0&id=2a9a340f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a340f",
  null
  
)

export default component.exports